import * as React from "react";
import "./coment.scss";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { makeStyles } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import BodyComent from "../../elements/BodyComent/BodyComent";
import EmojiPicker, { Categories } from "emoji-picker-react";
import { setComentShow, setComentHide } from "../../store/comentSelector";
import { useEffect, useState } from "react";
import { grey } from "@mui/material/colors";
import TextField from "@mui/material/TextField";
import { useSelector, useDispatch } from "react-redux";
import Stack from "@mui/material/Stack";
import { ApiUrl } from "../../env";
import { Link } from "react-router-dom";
import axios from "axios";
import { deepOrange } from "@mui/material/colors";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import Collapse from "@mui/material/Collapse";

const Dia = styled(Dialog)(({ theme }) => ({
  // backgroundColor: theme.color.main,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.color.main,
  "& .MuiPaper-root": {
    width: "100%", // Растягиваем на всю ширину
    maxWidth: "600px", // Ограничиваем сверху, чтобы не было слишком широкого контента
    margin: 0,
    padding: 0,
    overflow: "hidden",
  },
}));
// const Dial = styled(DialogContent)(({ theme }) => ({
//   backgroundColor: theme.color.main,
//   padding: theme.spacing(0),
//   textAlign: "center",
//   color: theme.color.secondary,
// }));

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: "rotate(0deg)",
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: "rotate(180deg)",
      },
    },
  ],
}));

const L = styled(Link)(({ theme }) => ({
  color: deepOrange[400],
  fontSize: "1.2rem",
  fontFamily: "Roboto",
}));

export default function ComentDialogs() {
  const [flag, setFlag] = useState(true);
  const comentShow = useSelector((state) => state.comentSelector.coment);
  const [comentAll, setComentAll] = useState(comentShow.coments);
  // const [comentAll, setComentAll] = useState("");
  const [coment, setComent] = useState("");
  const token = useSelector((state) => state.userSelector.token);
  const dispatch = useDispatch();
  const inputRef = React.createRef(null);
  const isAuthorized = useSelector((state) => state.userSelector.authorized);
  const MyCategories = [
    {
      category: Categories.SUGGESTED,
      name: "Популярные",
      // icon: "", // Убираем иконку

      // name: null,
      // icon: <img src="logo192.png" alt="Recent" />,
      // icon: null,
    },

    {
      category: Categories.SMILEYS_PEOPLE,
      name: "Смайлы&Люди",
    },
    {
      category: Categories.FOOD_DRINK,
      name: "Еда&напитки",
    },
    {
      category: Categories.ACTIVITIES,
      name: "Активность",
    },
  ];
  // const handleClickOpen = () => {
  //   setOpen(true);
  // };
  const handleClose = () => {
    dispatch(setComentHide());
  };

  const sendComent = () => {
    axios
      .post(`${ApiUrl}/api/coment`, {
        coment: coment,
        token: token,
        id: comentShow.id,
      })
      .then((response) => {
        setExpanded(false);
        inputRef.current.value = ""; // Очистка поля
        setComent("");
        setComentAll(response.data.coments[0].coments);
      })
      .catch((error) => {
        // Если запрос не будет выполнен, то ошибка выводится в терминал
        console.error(error);
      });
  };
  const updateComent = () => {
    axios
      .get(`${ApiUrl}/api/comentupdate/${comentShow.id}`, {})
      .then((response) => {
        setComentAll(response.data.coments[0].coments);
        // dispatch(setComentShow(response.data.coments[0]));
      })
      .catch((error) => {
        // Если запрос не будет выполнен, то ошибка выводится в терминал
        console.error(error);
      });
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      updateComent();
    }, 5000); // Интервал в миллисекундах (1 секунда)
    return () => clearInterval(interval); // Очистка интервала при размонтировании компонента
  }, []);

  useEffect(() => {
    updateComent();
  }, [flag]);
  // const classes = useStyles();
  return (
    <Dia
      // classes={{ root: classes.root }}
      // sx={{ "& .MuiPaper-root": { margin: -5 } }}
      // sx={{
      //   margin: 0,
      //   padding: 0,
      //   "&&.MuiDialog-paper": { border: "5px solid #ec1414" },
      // }}
      // fullWidth="true"
      // maxWidth="sm"
      // PaperProps={{
      //   sx: {
      //     width: "100%",
      //     maxWidth: "400px", // Можно задать свой максимум
      //   },
      // }}
      // sx={{
      //   "& .MuiPaper-root": {
      //     width: "100%", // Растягиваем на всю ширину
      //     maxWidth: "600px", // Ограничиваем сверху, чтобы не было слишком широкого контента
      //     margin: 0,
      //     padding: 0,
      //     overflow: "hidden",
      //   },
      // }}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={comentShow}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Коментарии
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Typography gutterBottom>
          <BodyComent coment={comentAll} token={token} disable={false} />
        </Typography>
      </DialogContent>
      {isAuthorized ? (
        <div>
          <div>
            <Stack direction="row" spacing={0} justifyContent="space-around">
              <TextField
                // backgroundColor="text.main"
                inputProps={{ maxLength: 500 }}
                placeholder="Коментарий"
                // variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  width: "100%",
                  // height: "70px",
                  marginLeft: "0px",
                  marginRight: "0px",
                }}
                inputRef={inputRef}
                onChange={(e) => setComent(e.target.value)}
                onfo
                id="coment"
                // label="коментарий"
                // variant="outlined"
                // sx={{ width: "100%", marginLeft: "0px" }}
                // error={coach_name_error}
                value={coment}
                slotProps={{ inputLabel: { shrink: true } }}
                // helperText={coach_name_error_helper_text}
              />
              <ExpandMore
                className="zoom-effect"
                expand={expanded}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
              >
                <EmojiEmotionsIcon />
              </ExpandMore>
              <div onClick={sendComent} className="zoom-effect">
                <IconButton aria-label="отправить">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.364 5.05026L3.10051 8.58579L10.8787 13.5355M19.364 5.05026L15.8284 21.3137L10.8787 13.5355M19.364 5.05026L10.8787 13.5355"
                      stroke="#000000"
                      stroke={grey[400]}
                    />

                    <defs>
                      <clipPath id="clip0_15_829">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </IconButton>
              </div>
            </Stack>
          </div>
          <div>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <EmojiPicker
                categories={MyCategories}
                style={{
                  // overflow: "hidden",
                  // position: "relative",
                  border: "0",
                  marginTop: "0px",
                  marginLeft: "0px",
                  marginRight: "0px",
                }}
                lazyLoadEmojis="true"
                searchDisabled="true"
                searchClearButtonLabel="Clear"
                width="600"
                height="300"
                onEmojiClick={(emojiObject) =>
                  setComent((e) => e + emojiObject["emoji"])
                }
              />
            </Collapse>
          </div>

          {/* <EmojiPicker
            categories={MyCategories}
            style={{
              marginTop: "3px",
              marginLeft: "-30px",
              marginRight: "-30px",
            }}
            lazyLoadEmojis="true"
            searchDisabled="true"
            width="600"
            onEmojiClick={(emojiObject) =>
              setComent((e) => e + emojiObject["emoji"])
            }
          /> */}
        </div>
      ) : (
        <Typography sx={{ m: 4 }}>
          Комментировать могут <L to="/lk">зарегистрированные</L> пользователи
        </Typography>
      )}
    </Dia>
  );
}
